import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-benutzer-hinzufuegen-multi';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRolleBenutzerHinzufuegenMultiEffects {

    RolleBenutzerHinzufuegenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_BENUTZER_HINZUFUEGEN_MULTI),
        mergeMap((x: ac.PostRolleBenutzerHinzufuegenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleBenutzerHinzufuegenMulti(x.rolleBenutzerMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleBenutzerHinzufuegenMultiErfolgreichAction(result, x.rolleBenutzerMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleBenutzerHinzufuegenMultiFehlerAction(error, x.rolleBenutzerMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
